import withErrorCheck from "../CheckError";
import server from "../Server";
import type { GetPlayerTotalsPayload, PlayerTotals } from "@grassrootly/api/gateways";

// Fetch aggregated player totals from Postgres view `player_totals_view`
export const GetPlayersTotals = async ({ pid }: GetPlayerTotalsPayload): Promise<PlayerTotals | null> => {
  const response = await server
    .from("player_totals_view")
    .select([
      "player_id",
      "total_goals_scored",
      "total_assists_made",
      "total_wins",
      "total_draws",
      "total_lost",
      "total_experience_points",
      "total_games",
    ].join(","))
    .eq("player_id", pid)
    .maybeSingle();

  const data = withErrorCheck<PlayerTotals | null>(response as any) || null;
  return data;
};
